import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { TOSHI_OS_ADD_POINTS_LOGS } from '../constants'

const retryAll = async (id: number) => {
  await fetchAPI({
    method: 'post',
    path: `/toshi_os_add_points_logs/manual_retry_all`,
  })
}

export const useRetryAll = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(retryAll, {
    onSuccess: async () => {
      await queryClient.refetchQueries([TOSHI_OS_ADD_POINTS_LOGS])

      toast({
        description: t('views.admin.users.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
